import { Outlet, useLocation } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import BackButton from 'src/features/navigation/components/BackButton';
import { PATH } from 'src/features/navigation/utils/constants';

export default function StatisticLayout() {
    const { pathname } = useLocation();

    //We use this logic when we open a new tab for capacity stats table
    //to navigate back to the PATH.STATISTICS page (only for this repo)
    const isOnCapacityStatsTablePage = pathname.includes(`${PATH.STATISTICS}/capacity-stats`);

    return (
        <>
            <BackButton customRoute={isOnCapacityStatsTablePage ? `/${PATH.STATISTICS}` : undefined} />
            <MainLayout>
                <Outlet />
            </MainLayout>
        </>
    );
}
